import React from 'react';
const SvgFile = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
    </svg>
  );
});
export default SvgFile;
SvgFile.iconName = 'file';
SvgFile.displayName = 'SvgFile';
